import { checkConditionFormDataErrors } from '../generic/utils';
import { IndexedEvent } from './hooks/useEventMappingHistory';

export type SelectOptionLike = {
  label: string | number;
  value: string | number | boolean;
};

export function validateEvents(events: IndexedEvent[]): any[] {
  return events
    .map(
      (event) =>
        checkConditionFormDataErrors(event.conditionFormData)?.errors ?? []
    )
    .flat();
}

export function validateEventFields(events: IndexedEvent[]): any[] {
  const errors: any[] = [];

  events.forEach((event, index) => {
    // Check if event field (task type/event/campaign type) is empty
    if (!event.event || event.event.trim() === '') {
      errors.push({
        level: 'event',
        index: 0,
        originalIndex: index,
      });
    }
  });

  return errors;
}
